import { render, staticRenderFns } from "./purifyAlloyManage.vue?vue&type=template&id=37e71cba&scoped=true&"
import script from "./purifyAlloyManage.vue?vue&type=script&lang=js&"
export * from "./purifyAlloyManage.vue?vue&type=script&lang=js&"
import style0 from "./purifyAlloyManage.vue?vue&type=style&index=0&id=37e71cba&scoped=true&lang=scss&"
import style1 from "./purifyAlloyManage.vue?vue&type=style&index=1&lang=css&"
import style2 from "./purifyAlloyManage.vue?vue&type=style&index=2&id=37e71cba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e71cba",
  null
  
)

export default component.exports